/* eslint-disable @typescript-eslint/no-explicit-any */

import ChartSkeleton from '../skeleton/ChartSkeleton'
import { useEffect, useId, useState } from 'react'
import { ColumnChartData } from '../../types/StatTypes'
import BaseChart from './BaseChart'

interface IColumnChartProps {
  chartData: ColumnChartData
}

const ColumnChart = (props: IColumnChartProps) => {
  const { chartData } = props
  const [isLoading, setIsLoading] = useState(true)
  const chartId = useId()

  useEffect(() => {
    if (chartData != undefined) {
      setIsLoading(true)
      const timer = setTimeout(() => setIsLoading(false), 300)
      return () => clearTimeout(timer)
    }
  }, [chartData])

  const options: any = {
    chart: {
      height: chartData.height,
      type: 'column',
      backgroundColor: 'transparent',
    },
    title: {
      text: null,
    },
    xAxis: {
      type: 'category',
      categories: chartData.categories,
      labels: {
        style: {
          color: chartData.textColor,
        },
      },
      lineColor: chartData.textColor,
    },
    yAxis: {
      min: 0,
      title: {
        text: '',
      },
      labels: {
        style: {
          color: chartData.textColor,
        },
      },
      gridLineColor: chartData.gridColor || '#E0E0E0',
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: chartData.seriesName,
        colorByPoint: true,
        data: chartData.data,
      },
    ],
    colors: chartData.colors,
    credits: {
      enabled: false,
    },
  }

  return <>{isLoading ? <ChartSkeleton fullWidth={true} /> : <BaseChart options={options} id={chartId} />}</>
}

export default ColumnChart
